import { onBeforeUpdate as _onBeforeUpdate2 } from "gyron";
import { onBeforeUpdate as _onBeforeUpdate } from "gyron";
import { h as _h } from "gyron";
import { createBrowserRouter, Route, Router, Routes } from '@gyron/router';
import { createSSRContext, FC } from 'gyron';
import { MdxHelper } from './components/helper';
import { MdxContainer } from './components/mdx';
import { Mismatch } from './components/mismatch';
import { Skeleton } from './components/skeleton';
import { Layout } from './layout';
import { CORE_INDEX, CoreDocs, CORE_ROUTE_MENUS, Docs, Home, ROUTE_MENUS, Editor, BlogDocs, BLOG_ROUTE_MENUS } from './pages';
import { storeState } from './store';
const base = process.env.PUBLISH_BASE;
const Content = FC(({
  menu,
  parentPath
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props = props;
    menu = _props.menu;
    parentPath = _props.parentPath;
  })
  return ({
    menu,
    parentPath
  }) => _h(MdxContainer, {
    "menu": menu,
    "parentPath": parentPath
  }, _h(menu.component, {
    "fallback": _h(Skeleton, {
      "length": 3
    }, []),
    "components": MdxHelper
  }, []));
});
export const ExposeRoutes = FC(() => {
  return () => _h(Routes, {}, [_h(Route, {
    "path": "",
    "strict": true,
    "meta": {
      title: '文档'
    },
    "element": _h(Home, {}, [])
  }, []), _h(Route, {
    "path": "docs",
    "element": _h(Docs, {}, [])
  }, ROUTE_MENUS.map(menu => _h(Route, {
    "path": menu.path,
    "meta": menu.meta,
    "element": _h(Content, {
      "menu": menu,
      "parentPath": "docs"
    }, [])
  }, []))), _h(Route, {
    "path": "core",
    "element": _h(CoreDocs, {}, [])
  }, [_h(Route, {
    "index": true,
    "meta": CORE_INDEX.meta,
    "element": _h(Content, {
      "menu": CORE_INDEX,
      "parentPath": "core"
    }, [])
  }, []), CORE_ROUTE_MENUS.map(menu => _h(Route, {
    "path": menu.path,
    "meta": menu.meta,
    "element": _h(Content, {
      "menu": menu,
      "parentPath": "core"
    }, [])
  }, []))]), _h(Route, {
    "path": "blog",
    "element": _h(BlogDocs, {}, [])
  }, BLOG_ROUTE_MENUS.map(menu => _h(Route, {
    "path": menu.path,
    "meta": menu.meta,
    "element": _h(Content, {
      "menu": menu,
      "parentPath": "blog"
    }, [])
  }, []))), _h(Route, {
    "path": "explorer",
    "meta": {
      title: '在线/协同 Gyron.js编辑器'
    },
    "element": _h(Editor, {}, [])
  }, []), _h(Route, {
    "path": "*",
    "meta": {
      title: '404 未找到页面'
    },
    "element": _h(Mismatch, {}, [])
  }, [])]);
});
export const App = FC(({
  isSSR
}) => {
  // Auxiliary update of deconstructed props
  _onBeforeUpdate((_, props) => {
    var _props2 = props;
    isSSR = _props2.isSSR;
  })
  return ({
    isSSR
  }) => _h(Layout, {}, _h(ExposeRoutes, {}, []));
});
export const app = () => {
  const router = createBrowserRouter({
    base: base || '/',
    beforeEach: (from, to, next) => {
      next();
    },
    afterEach: (from, to) => {
      if (to.meta) {
        const title = `Gyron.js | ${to.meta.title}`;
        document.title = title;
        const og = document.querySelector('meta[property="og:title"]');
        if (og) {
          og.content = title;
        }
      }
      if (from.path !== to.path) {
        for (const k in storeState.guidance) {
          Reflect.deleteProperty(storeState.guidance, k);
        }
      }
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  });
  return createSSRContext({
    message: {}
  }).render(_h(Router, {
    "router": router
  }, _h(App, {}, [])), '#app');
};